import { BookOpen, Award, Volume2, LineChart } from "lucide-react";

/**
 * WhyPay — Answer the "Duolingo / ChatGPT are free, why pay?" objection.
 *
 * 4 differentiators honnêtes, formulés en bénéfices concrets.
 * Reste vrai même sans clients : ces points sont des fonctionnalités
 * qui existent réellement dans le produit, vérifiables par tout visiteur.
 */
const POINTS = [
  {
    icon: BookOpen,
    kicker: "Parcours structuré",
    title: "Un chemin linéaire pensé pour les francophones",
    body:
      "Duolingo enseigne le japonais depuis l'anglais, avec des tournures parfois maladroites. Ici, 200 leçons ordonnées du N5 au N3, écrites en français, qui s'appuient sur les repères d'un francophone : conjugaison, particules, ordre des mots, tout expliqué avec vos codes.",
  },
  {
    icon: Award,
    kicker: "Objectif JLPT",
    title: "Un entraînement chronométré, pas juste des cartes",
    body:
      "Les apps gratuites ne vous mettent jamais en conditions. Nos examens blancs sont des QCM minutés qui couvrent le vocabulaire, la grammaire, les kanji et la lecture du N5, pour vous entraîner à répondre vite et sans hésiter avant le jour J.",
  },
  {
    icon: Volume2,
    kicker: "Audio dans chaque exercice",
    title: "Une vraie prononciation, pas une voix sans âme",
    body:
      "Derrière Japonais Pas à Pas, un couple franco-japonais. Atsuko est japonaise et veille à ce que chaque mot, chaque phrase, chaque dialogue sonne naturel, comme au Japon. L'audio est intégré à chaque exercice pour former votre oreille sans effort.",
  },
  {
    icon: LineChart,
    kicker: "Progression suivie",
    title: "Un tuteur qui vous corrige, pas juste une note",
    body:
      "Une app gratuite vous laisse répéter dans le vide. Ici, un quiz de validation après chaque leçon vous oblige à prouver que vous avez compris avant d'avancer, et le tuteur Sensei IA, en français, répond à vos questions et vous fait pratiquer autant que vous voulez, quand vous voulez.",
  },
];

export function WhyPay() {
  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-12 py-24" data-testid="why-pay-section">
      <div className="max-w-3xl mb-14">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#E94A3F] mb-3">
          Pourquoi payer si Duolingo ou ChatGPT sont gratuits ?
        </div>
        <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tighter leading-[1] text-[#1A2A40]">
          Quatre choses qu'une app <span className="italic font-light">gratuite</span> ne fera pas pour vous.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {POINTS.map((p, i) => {
          const Icon = p.icon;
          return (
            <div
              key={i}
              data-testid={`why-pay-item-${i}`}
              className="bg-[#FDFBF7] rounded-3xl p-8 border-2 border-[#1A2A40]/10 hover-lift"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-xl bg-[#FFD166]/40 flex items-center justify-center border-2 border-[#1A2A40]/10">
                  <Icon className="w-5 h-5 text-[#E94A3F]" />
                </div>
                <div className="text-xs font-bold uppercase tracking-widest text-[#4A5568]">{p.kicker}</div>
              </div>
              <h3 className="font-display font-black text-2xl leading-tight text-[#1A2A40] mb-3">
                {p.title}
              </h3>
              <p className="text-[#4A5568] leading-relaxed">{p.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default WhyPay;
